import { USERS_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import {
  CompletePasswordResetArg,
  CompletePasswordResetResponse,
  EmailConfirmationArg,
  EmailConfirmationResponse,
  InitiatePasswordResetArg,
  InitiatePasswordResetResponse,
  VerifyPasswordResetArg,
  VerifyPasswordResetResponse,
} from "../types";

const passwordResetApi = api.injectEndpoints({
  endpoints: (build) => ({
    emailConfirmation: build.mutation<
      EmailConfirmationResponse,
      EmailConfirmationArg
    >({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/email-confirmation`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    initiatePasswordReset: build.mutation<
      InitiatePasswordResetResponse,
      InitiatePasswordResetArg
    >({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/password-reset/initiate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    verifyPasswordReset: build.query<
      VerifyPasswordResetResponse,
      VerifyPasswordResetArg
    >({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/password-reset/${queryArg.verificationToken}`,
      }),
    }),
    completePasswordReset: build.mutation<
      CompletePasswordResetResponse,
      CompletePasswordResetArg
    >({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/password-reset/complete`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { passwordResetApi };

export const {
  useEmailConfirmationMutation,
  useInitiatePasswordResetMutation,
  useCompletePasswordResetMutation,
  useVerifyPasswordResetQuery,
} = passwordResetApi;
